import * as React from "react";
import { useParams } from "react-router-dom";
import { useState } from "react";
//   import styles from './ClientPage.module.scss';
import styles2 from "./../../components/InformationsForms/InformationFormsStyle.module.scss";
import Button from "../../components/ReusableElements/Button/Button";
import ClientHistory from "../../components/ClientHistory/ClientHistory";
import Claim from "../../components/Claim/Claim";
import { baseUrl } from "../../common/constants";
import { toast } from "react-toastify";
import NameField from "../../components/ReusableComponent/NameFields";
import FullAddressField from "../../components/ReusableComponent/FullAddress";
import AddressField from "../../components/ReusableComponent/AddressField";
import ContactsFields from "../../components/ReusableComponent/ContactsFields";
import FormButtons from "./../../components/InformationsForms/FormButtons";
import { formatAddress } from "../../components/ReusableComponent/Common";
import UploadDocumentModal from "../../modals/UploadDocumentModal";
import _axios from "../../utils/api/_axios";
import { Col, Form, Input, Modal, Row, Radio, Card } from "antd";
import { Content } from "antd/es/layout/layout";
import { EditOutlined, HistoryOutlined, PlusOutlined } from "@ant-design/icons";
import Loading from "../../components/Loader/Loading";
import { mainContext } from "../../context/context";
import TextArea from "antd/es/input/TextArea";

export default function ClientPage() {
  const childRef = React.useRef();
  const { id } = useParams();
  const [patientId, setPatientId] = React.useState(id);
  const [claimId, setClaimId] = React.useState("");
  const [loading, setLoading] = useState(false);
  const { selectedPatient, getNotesData } = React.useContext(mainContext);
  const [selectedClaim, setSelectedClaim] = useState();
  const [isFullHistoryModalOpen, setIsFullHistoryModalOpen] = useState(false);
  const [fullHistoryNotes, setFullHistoryNotes] = useState([]);
  const [isAddingNote, setIsAddingNote] = useState(false);
  const [newNoteText, setNewNoteText] = useState('');
  const [patientInfo, setPatientInfo] = React.useState({
    height: {
      feet: 5,
      inches: 10,
    },
    languages: [],
    preferredLanguages: [],
    _id: "64ac4b06d5fb938c07599164",
    patientUniqueId: "2321",
    firstName: "Joshn",
    lastName: "Dose",
    claimNumber: "ABC1232",
    date: "2023-06-17T00:00:00.000Z",
    injury: "Headache",
    dateOfBirth: "1990-01-01T00:00:00.000Z",
    gender: "Male",
    weight: 180,
    phone1: "1234567890",
    workPhone: "9876543210",
    ext: "123",
    alternatePhone: "5678901234",
    alternateDescription: "Family",
    email: "john.doe@example.com",
    patient_address1: "123 Main Street",
    patient_address2: "Apt 4B",
    patient_city: "New York",
    patient_state: "NY",
    patient_zip: "12345",
    __v: 0,
    mobile: "0987654321",
    wcbNumber: "123456",
  });

  const [patientClaims, setPatientClaims] = React.useState([]);
  const [selectedRadio, setSelectedRadio] = useState("");

  const setValues = (payloadData) => {
    const payload = payloadData.patientInfo;
    setPatientInfo({
      height: {
        feet: payload.height.feet,
        inches: payload.height.inches,
      },
      languages: payload.languages,
      _id: payload._id,
      patientUniqueId: payload.patientUniqueId,
      firstName: payload.firstName,
      lastName: payload.lastName,
      claimNumber: payload.claimNumber,
      date: new Date(payload.date)
        .toLocaleDateString("en-US", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        })
        .split("/")
        .join("-"),
      injury: payload.injury,
      dateOfBirth: new Date(payload?.dateOfBirth).toISOString().split("T")[0],
      gender: payload.gender,
      weight: payload.weight,
      phone1: payload.phone1,
      workPhone: payload.workPhone,
      ext: payload.ext,
      alternatePhone: payload.alternatePhone,
      alternateDescription: payload.alternateDescription,
      email: payload.email,
      patient_address1: payload.patient_address1,
      patient_address2: payload.patient_address2,
      patient_city: payload.patient_city,
      patient_state: payload.patient_state,
      patient_zip: payload.patient_zip,
      __v: 0,
      mobile: payload.mobile,
      wcbNumber: payload.wcbNumber,
      languages:
        payload.languages[0] != "Speaks English"
          ? "prefers"
          : payload.languages[0],
      preferredLanguages:
        payload.languages[0] != "Speaks English"
          ? payload.languages[0]
          : "prefers",
    });
  };

  const map = (patientInfo) => {
    return {
      height: {
        feet: patientInfo.height.feet,
        inches: patientInfo.height.inches,
      },
      languages:
        patientInfo.languages == "prefers"
          ? patientInfo.preferredLanguages
          : patientInfo.languages,
      _id: patientInfo._id,
      patientUniqueId: patientInfo.patientUniqueId,
      firstName: patientInfo.firstName,
      lastName: patientInfo.lastName,
      claimNumber: patientInfo.claimNumber,
      date: patientInfo.date,
      injury: patientInfo.injury,
      dateOfBirth: patientInfo.dateOfBirth,
      gender: patientInfo.gender,
      weight: patientInfo.weight,
      phone1: patientInfo.phone1,
      workPhone: patientInfo.workPhone,
      ext: patientInfo.ext,
      alternatePhone: patientInfo.alternatePhone,
      alternateDescription: patientInfo.alternateDescription,
      email: patientInfo.email,
      patient_address1: patientInfo.patient_address1,
      patient_address2: patientInfo.patient_address2,
      patient_city: patientInfo.patient_city,
      patient_state: patientInfo.patient_state,
      patient_zip: patientInfo.patient_zip,
      wcbNumber: patientInfo.wcbNumber,
      __v: patientInfo.__v,
      mobile: patientInfo.mobile,
    };
  };

  const fetchPatient = async (id) => {
    if (id) {
      try {
        const response = await _axios.get(`${baseUrl}/patients/${id}`);
        setValues(response.data.payload);
      } catch (error) {
        console.error("Error fetching users:", error);
        toast.error("Error fetching patient data");
      }
    } else {
      toast.error("The patient you are looking for does not exists");
    }
  };
  //here
  const fetchClaims = async (patientId) => {
    setLoading(true);
    if (patientId) {
      try {
        const response = await _axios.get(
          `${baseUrl}/patients/${patientId}/claims/`
        );
        setPatientClaims(response.data.payload); // Ensure correct state update
        setSelectedClaim(response.data.payload[0]); // Set the first claim as selected by default
      } catch (error) {
        console.error("Error fetching claims:", error);
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  };

  //here
  const updateHistory = (claimId) => {
    if (childRef.current) {
      childRef.current.childMethod(patientId, claimId); // Ensure only this claim's history is fetched
    } else {
      console.warn("childRef is not available");
    }
  };

  React.useEffect(() => {
    if (id) {
      setPatientId(id);
      fetchPatient(id);
      fetchClaims(id);
    }
  }, []);

  const [isEditing, setIsEditing] = React.useState(false);
  const [isPatientEditModalOpen, setIsPatientEditModalOpen] =
    React.useState(false);
  const [isUploadDocumentModalOpen, setIsUploadDocumentModalOpen] =
    React.useState(false);

  const openPatientEditModal = () => {
    setIsPatientEditModalOpen(true);
  };

  const closePatientEditModal = () => {
    setIsPatientEditModalOpen(false);
  };

  const openUploadDOcumentModal = () => {
    setIsUploadDocumentModalOpen(true);
  };

  const closeUploadDocumentModal = () => {
    setIsUploadDocumentModalOpen(false);
  };

  const handleClose = () => {
    setIsEditing(false);
    setIsPatientEditModalOpen(false);
    window.location.reload();
  };

  const handleEditClick = () => {
    setIsEditing(true);
  };
  //here
  const handleClaim = (claimId) => {
    setClaimId(claimId);
    // Find the selected claim from already fetched patientClaims
    const selected = patientClaims.find((claim) => claim._id === claimId);
    console.log("patientClaims:", patientClaims); // Debugging line
    console.log("Selected claim:", selected); // Debugging line
    if (selected) {
      setSelectedClaim(selected); // Set selected claim data in state
      updateHistory(claimId); // Still call history update as before
    } else {
      console.warn("Selected claim not found in patientClaims");
    }
  };

  React.useEffect(() => {
    if (patientClaims?.length > 0 && !claimId) {
      handleClaim(patientClaims[0]._id); // or setClaimId(patientClaims[0]._id);
    }
  }, [patientClaims]);

  const handleHeightChange = (e, propertyName) => {
    const { value } = e.target;
    setPatientInfo((prevPatientInfo) => ({
      ...prevPatientInfo,
      height: {
        ...prevPatientInfo.height,
        [propertyName]: value,
      },
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPatientInfo((prevPatientInfo) => ({
      ...prevPatientInfo,
      [name]: value,
    }));
  };

  const handleChangeValue = (e) => {
    setSelectedRadio(e.target.value);
    setPatientInfo({ ...patientInfo, languages: e.target.value });
  };

  const handleShowFullHistory = async () => {
    try {
       const response = await _axios.get(`${baseUrl}/history/patient/${patientId}`);
      if (response.status === 200) {
        setFullHistoryNotes(response.data.payload);
        setIsFullHistoryModalOpen(true);
      } else {
        toast.error("Failed to fetch full history");
      }
    } catch (error) {
      console.error(error);
      toast.error("Error fetching full history");
    }
  };
  
  const handleAddNote = async () => {
    if (!newNoteText.trim()) {
      toast.warning("Note cannot be empty.");
      return;
    }
  
    try {
      const addClaim = claimId ? `/claim/${claimId}` : "";
      const response = await _axios.post(
        `${baseUrl}/history/patient/${patientId}${addClaim}`,
        { descriptions: [newNoteText] },
        { headers: { 'Content-Type': 'application/json' } }
      );
  
      if (response.status === 201) {
        toast.success("Note added successfully!");
        setNewNoteText('');
        setIsAddingNote(false);
        // Refresh history if needed
        if (typeof getNotesData === "function") {
          getNotesData(patientId, claimId); // or fetchFullHistoryNotes if you have a separate function for that modal
        }
      } else {
        toast.error("Failed to add note.");
      }
    } catch (error) {
      console.error(error);
      toast.error("An error occurred while adding the note.");
    }
  };
  

  const handleUpdate = async (event) => {
    event.preventDefault();
    setIsEditing(false);
    try {
      const response = await _axios.put(
        `${baseUrl}/patients/${patientId}`,
        map(patientInfo)
      );

      if (response.status === 200) {
        toast.success("Patient information updated successfully");
        setIsEditing(false);
        setIsPatientEditModalOpen(false);
      } else {
        toast.error("Failed to update patient information");
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to update patient.");
    }
  };
  return (
    <Content className="px-5">
      <div className="p-5">
        <Row gutter={16}>
          {/* Client Info Card - Stays at the Top */}
          <Col xs={24} lg={24} className="mb-4">
            <Card className="bg-white shadow-md rounded-lg max-h-[350px]">
              {/* Header */}
              <div className="bg-gray-800 text-white flex justify-between items-center px-3 py-2 rounded-t-lg">
                <div>{`Client Info RSS#${patientInfo.patientUniqueId}`}</div>
                <div className="flex items-center gap-3">
                  {/* Show History Button */}
                  <div
                    className="cursor-pointer flex items-center gap-2 text-green-400"
                    onClick={handleShowFullHistory} // Make sure this function is defined
                  >
                    <div>Show All History</div>
                    <HistoryOutlined className="text-xl" />
                  </div>

                  {/* Upload Documents */}
                  <div
                    className="cursor-pointer flex items-center gap-2"
                    onClick={openUploadDOcumentModal}
                  >
                    {/* <span>Documents</span> */}
                  </div>

                  {/* Edit Button */}
                  <div
                    className="cursor-pointer flex items-center gap-2"
                    onClick={() => {
                      handleEditClick();
                      openPatientEditModal();
                    }}
                  >
                    <div className="text-blue-500">Edit</div>
                    <EditOutlined className="text-xl text-blue-500" />
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="p-3">
                <Row gutter={16}>
                  <Col xs={24} lg={12}>
                    <div>
                      <div className="flex flex-wrap">
                        <div>
                          <b>Customer Claim</b>
                        </div>
                        <div>: {`${patientInfo.claimNumber}`}</div>
                      </div>
                      <div>
                        <b>Customer Name: </b> {patientInfo.firstName}{" "}
                        {patientInfo.lastName}
                      </div>
                      <div>
                        <b>WCB number: </b> {patientInfo.wcbNumber}
                      </div>
                      <div>
                        <b>Gender: </b> {patientInfo.gender}
                      </div>
                      <div className="flex gap-6">
                        <div>
                          <b>Height: </b>{" "}
                          {patientInfo.height.feet
                            ? `${patientInfo.height.feet}' ${patientInfo.height.inches}"`
                            : null}
                        </div>
                        <div>
                          <b>Weight: </b>{" "}
                          {patientInfo.weight
                            ? `${patientInfo.weight} lbs`
                            : null}
                        </div>
                      </div>
                      <div>
                        <b>Date Of Birth: </b>{" "}
                        {new Date(patientInfo.dateOfBirth).toLocaleDateString(
                          "en-US",
                          { day: "2-digit", month: "2-digit", year: "numeric" }
                        )}
                      </div>
                      <div>
                        <b>Language: </b>{" "}
                        {patientInfo.languages === "prefers"
                          ? patientInfo.preferredLanguages
                          : patientInfo.languages}
                      </div>
                    </div>
                  </Col>

                  <Col xs={24} lg={12}>
                    <div>
                      <div className="flex items-center gap-2">
                        <div className="font-bold">Customer Unique ID:</div>
                        <div>{`RSS#${patientInfo.patientUniqueId}`}</div>
                      </div>

                      {patientInfo.email && (
                        <div>
                          <b>Email: </b>
                          {patientInfo.email}
                        </div>
                      )}
                      {patientInfo.workPhone && (
                        <div>
                          <b>Work phone: </b>
                          {patientInfo.workPhone}
                        </div>
                      )}
                      {patientInfo.mobile && (
                        <div>
                          <b>Mobile: </b>
                          {patientInfo.mobile}
                        </div>
                      )}
                      {patientInfo.phone1 && (
                        <div>
                          <b>Home Phone: </b>
                          {patientInfo.phone1} (<b>Ext: </b>
                          {patientInfo.ext})
                        </div>
                      )}
                      {patientInfo.alternatePhone && (
                        <div>
                          <b>Alternate Phone: </b>
                          {patientInfo.alternatePhone}
                        </div>
                      )}
                      {patientInfo.alternateDescription && (
                        <div>
                          <b>Alternate phone description: </b>
                          {patientInfo.alternateDescription}
                        </div>
                      )}
                      <div>
                        <b>Address: </b>
                        {patientInfo.patient_address1}{" "}
                        {patientInfo.patient_address2}{" "}
                        {patientInfo.patient_city} {patientInfo.patient_state}{" "}
                        {patientInfo.patient_zip}
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </Card>
          </Col>
        </Row>

        {/* Claims and History Section */}
        <Row gutter={16} className="w-full">
          {/* Claims List Card (Left Side) */}
          <Col xs={24} lg={6}>
            <Card className="bg-white shadow-md rounded-lg h-full">
              <div className="bg-gray-800 text-white p-3 font-semibold rounded-md">
                Claims List
              </div>
              <div className="p-2 space-y-3">
                {patientClaims?.length > 0 ? (
                  patientClaims.map((claim, index) => {
                    // Define dynamic color classes based on claim status
                    const statusColors = {
                      Unassigned: "bg-yellow-500 text-white",
                      Scheduled: "bg-green-500 text-white",
                      New: "bg-red-500 text-white",
                      PaymentAwaited: "bg-blue-500 text-white",
                    };

                    return (
                      <button
                        key={claim._id || index} // Ensure a unique key even if _id is missing
                        className={`w-full p-4 border border-gray-300 rounded-md flex flex-col text-left transition duration-200
                ${
                  claimId === claim._id
                    ? "bg-gray-200 border-blue-500 shadow-md"
                    : "hover:bg-gray-100"
                }`}
                        onClick={() => handleClaim(claim._id)}
                      >
                        {/* Claim Number */}
                        <div className="text-gray-800 font-semibold">
                          #{claim.claimNumber}
                        </div>

                        {/* Unique Claim ID */}
                        {/* <div className="text-gray-600 text-xs mt-1">
                <span className="font-medium">Claim ID:</span> {claim._id}
              </div> */}

                        {/* Status */}
                        <div
                          className={`px-3 py-1 text-xs font-medium rounded-full mt-2 w-fit 
                ${statusColors[claim.status] || "bg-gray-400 text-white"}`}
                        >
                          {claim.status === "PaymentAwaited"
                            ? "Payment Awaited"
                            : claim.status}
                        </div>

                        {/* Claim Type */}
                        <div className="text-gray-600 text-sm mt-2">
                          <span className="font-medium">Claim Type:</span>{" "}
                          {claim.claimType || "N/A"}
                        </div>

                        {/* Date Filed */}
                        <div className="text-gray-500 text-xs mt-1">
                          <span className="font-medium">Date Filed:</span>
                          {new Date(claim.createdAt).toLocaleDateString(
                            "en-US",
                            {
                              month: "2-digit",
                              day: "2-digit",
                              year: "2-digit",
                            }
                          )}
                        </div>
                      </button>
                    );
                  })
                ) : (
                  <p className="text-gray-500 text-center">
                    No claims available
                  </p>
                )}
              </div>
            </Card>
          </Col>

          {/* Right Side (Patient Claims and History) */}
          <Col xs={24} lg={18}>
            <div className="flex flex-col gap-6">
              {/* Patient Claims Card */}
              <Card className="bg-white shadow-md rounded-lg p-4 h-full flex flex-col">
                <div className="border-b pb-3 mb-3 text-lg font-semibold text-gray-800">
                  Patient Claim
                </div>
                {loading ? (
                  <div className="flex justify-center flex-grow">
                    <Loading isCircular={true} />
                  </div>
                ) : (
                  <div className="flex justify-center p-2">
                    {patientClaims?.length > 0 ? (
                      <Claim
                        patientId={id}
                        handleClaim={handleClaim}
                        key={selectedClaim._id}
                        claim={selectedClaim}
                      />
                    ) : (
                      <p className="text-gray-500 text-center">
                        No claims available
                      </p>
                    )}
                  </div>
                )}
              </Card>

              {/* History Card (Same Width as Patient Claims) */}
              <Card className="bg-white shadow-md rounded-lg p-4 flex flex-col">
                <div className="border-b pb-3 mb-3 text-lg font-semibold text-gray-800 flex justify-between">
                  <div>History</div>
                </div>

                {/* Ensure this div has the correct ID */}
                <div id="ClientHistory" className="pt-3 p-2">
                  <ClientHistory
                    patientId={patientId}
                    claimId={claimId}
                    ref={childRef}
                  />
                </div>
              </Card>
            </div>
          </Col>
        </Row>
      </div>

      {/* Modal Section (UNCHANGED) */}
      <Modal
        open={isPatientEditModalOpen}
        onCancel={handleClose}
        footer={null}
        centered
        width={800}
      >
        <form
          onSubmit={handleUpdate}
          className="p-6 bg-white rounded-lg shadow-md"
        >
          {/* Header */}
          <div className="mb-6 border-b pb-4 bg-gray-800 text-white px-6 py-4 rounded-t-lg">
            <h4 className="text-xl font-semibold">
              Edit Patient - RSS#{patientInfo.patientUniqueId}
            </h4>
          </div>

          {/* Form Container */}
          <div className="border p-6 rounded-lg bg-gray-50">
            <NameField
              onChange={(e) => handleChange(e)}
              formValues={patientInfo}
            />
            <FullAddressField
              onChange={(e) => handleChange(e)}
              formValues={patientInfo}
              prefix="patient_"
            />
            <AddressField
              onChange={(e) => handleChange(e)}
              formValues={patientInfo}
              prefix="patient_"
            />

            {/* Personal Details */}
            <Row className="grid grid-cols-2 gap-6">
              <Col>
                <Form.Item label="Date Of Birth">
                  <Input
                    type="date"
                    className="w-full h-14 px-4 text-lg border rounded-md focus:ring-2 focus:ring-blue-500"
                    onChange={(e) => handleChange(e)}
                    name="dateOfBirth"
                    value={patientInfo?.dateOfBirth}
                  />
                </Form.Item>
              </Col>
              <Col>
                <Form.Item label="Gender">
                  <Radio.Group
                    onChange={(e) => handleChange(e)}
                    value={patientInfo.gender}
                    name="gender"
                    className="flex gap-6"
                  >
                    <Radio value="female">Female</Radio>
                    <Radio value="male">Male</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
            </Row>

            {/* Height & Weight */}
            <Row className="grid grid-cols-2 gap-6">
              <Col>
                <Form.Item label="Height (Feet & Inches)">
                  <div className="flex gap-4">
                    <Input
                      type="number"
                      className="w-1/2 h-14 px-4 text-lg border rounded-md focus:ring-2 focus:ring-blue-500"
                      placeholder="Feet"
                      onChange={(e) => handleHeightChange(e, "feet")}
                      name="feet"
                      value={patientInfo.height.feet}
                    />
                    <Input
                      type="number"
                      className="w-1/2 h-14 px-4 text-lg border rounded-md focus:ring-2 focus:ring-blue-500"
                      placeholder="Inches"
                      onChange={(e) => handleHeightChange(e, "inches")}
                      name="inches"
                      value={patientInfo.height.inches}
                    />
                  </div>
                </Form.Item>
              </Col>
              <Col>
                <Form.Item label="Weight (lbs)">
                  <Input
                    type="number"
                    className="w-full h-14 px-4 text-lg border rounded-md focus:ring-2 focus:ring-blue-500"
                    placeholder="Weight (lbs)"
                    name="weight"
                    onChange={(e) => handleChange(e)}
                    value={patientInfo.weight}
                  />
                </Form.Item>
              </Col>
            </Row>

            {/* Contact Information */}
            <Row className="grid grid-cols-3 gap-6">
              <Col>
                <Form.Item label="Email">
                  <Input
                    className="w-full h-14 px-4 text-lg border rounded-md focus:ring-2 focus:ring-blue-500"
                    placeholder="Email"
                    name="email"
                    onChange={(e) => handleChange(e)}
                    value={patientInfo?.email || ""}
                  />
                </Form.Item>
              </Col>
              <Col>
                <Form.Item label="WCB Number">
                  <Input
                    className="w-full h-14 px-4 text-lg border rounded-md focus:ring-2 focus:ring-blue-500"
                    placeholder="WCB Number"
                    name="wcbNumber"
                    onChange={(e) => handleChange(e)}
                    value={patientInfo?.wcbNumber || ""}
                  />
                </Form.Item>
              </Col>

              <Col>
                <Form.Item label="Phone 1">
                  <Input
                    className="w-full h-14 px-4 text-lg border rounded-md focus:ring-2 focus:ring-blue-500"
                    placeholder="Phone 1"
                    name="phone1"
                    onChange={(e) => handleChange(e)}
                    value={patientInfo.phone1 || ""}
                  />
                </Form.Item>
              </Col>
            </Row>

            {/* Phone Numbers */}
            <Row className="grid grid-cols-3 gap-6">
              <Col>
                <Form.Item label="Ext.">
                  <Input
                    className="w-full h-14 px-4 text-lg border rounded-md focus:ring-2 focus:ring-blue-500"
                    placeholder="Ext"
                    name="ext"
                    onChange={(e) => handleChange(e)}
                    value={patientInfo.ext || ""}
                  />
                </Form.Item>
              </Col>
              <Col>
                <Form.Item label="Work Phone">
                  <Input
                    className="w-full h-14 px-4 text-lg border rounded-md focus:ring-2 focus:ring-blue-500"
                    placeholder="Work Phone"
                    name="workPhone"
                    onChange={(e) => handleChange(e)}
                    value={patientInfo.workPhone || ""}
                  />
                </Form.Item>
              </Col>

              <Col>
                <Form.Item label="Mobile">
                  <Input
                    className="w-full h-14 px-4 text-lg border rounded-md focus:ring-2 focus:ring-blue-500"
                    placeholder="Mobile"
                    name="mobile"
                    onChange={(e) => handleChange(e)}
                    value={patientInfo.mobile || ""}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row className="grid grid-cols-3 gap-6">
              <Col>
                <Form.Item label="Alternate Phone">
                  <Input
                    className="w-full h-14 px-4 text-lg border rounded-md focus:ring-2 focus:ring-blue-500"
                    placeholder="Alternate Phone"
                    name="alternatePhone"
                    onChange={(e) => handleChange(e)}
                    value={patientInfo.alternatePhone || ""}
                  />
                </Form.Item>
              </Col>
            </Row>

            {/* Language Preferences */}
            <Row className="grid grid-cols-2 gap-6">
              <Col>
                <Form.Item label="Languages">
                  <Radio.Group
                    name="languages"
                    value={patientInfo.languages}
                    defaultValue="Speaks English"
                    onChange={handleChangeValue}
                  >
                    <Radio className="mr-4" value="Speaks English">
                      Speaks English
                    </Radio>
                    <Radio value="prefers">Limited English, Prefers</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
              <Col>
                <Form.Item label="Preferred Language">
                  <Input
                    className="w-full h-14 px-4 text-lg border rounded-md focus:ring-2 focus:ring-blue-500"
                    placeholder="Preferred Language"
                    name="preferredLanguages"
                    disabled={patientInfo.languages !== "prefers"}
                    onChange={(e) => handleChange(e)}
                    value={patientInfo.preferredLanguages}
                  />
                </Form.Item>
              </Col>
            </Row>

            {/* Submit & Cancel Buttons */}
            <div className="flex justify-end gap-4 mt-6">
              <button
                type="button"
                className="px-6 py-3 text-lg font-semibold text-white bg-red-500 rounded-md hover:bg-red-600"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="px-6 py-3 text-lg font-semibold text-white bg-blue-500 rounded-md hover:bg-blue-600"
              >
                Save Changes
              </button>
            </div>
          </div>
        </form>
      </Modal>

      <Modal
  title={null}
  open={isFullHistoryModalOpen}
  onCancel={() => setIsFullHistoryModalOpen(false)}
  footer={null}
  width={800}
>
  {/* Header Section */}
  <div className=" text-gray-600 flex justify-between items-center px-3 py-2 rounded-t-lg mb-2">
    <div className="text-lg font-semibold">Complete History</div>
  </div>

  {/* Add Note Button */}
  <div className="flex justify-end mb-4 px-3">
    <div
      className="cursor-pointer flex items-center gap-2 text-white bg-gray-600 rounded-md px-4 py-2 hover:bg-gray-700 transition duration-200"
      onClick={() => setIsAddingNote(true)}
    >
      <div>Add Note</div>
      <PlusOutlined className="text-xl" />
    </div>
  </div>

  {/* Notes Content */}
  <div className="max-w-full w-full px-3">
    {fullHistoryNotes.length > 0 ? (
      fullHistoryNotes.map((note, index) => (
        <div key={index} className="bg-white shadow-md rounded-lg p-4 mb-4">
          <div className="text-lg font-semibold text-gray-900">{note.title}</div>
          <ul className="list-disc pl-5 text-gray-700">
            {note.descriptions?.map((description, i) => (
              <li key={i}>{description}</li>
            ))}
          </ul>
          <div className="italic text-sm text-gray-600">
            Posted by {note.createdBy || "Admin"} on{" "}
            {new Date(note.createdAt).toLocaleString()}
          </div>
        </div>
      ))
    ) : (
      <div className="text-gray-600 px-2">No history available.</div>
    )}
  </div>
</Modal>

{/* Add Note Modal */}
<Modal
  title="Add Note"
  open={isAddingNote}
  onCancel={() => setIsAddingNote(false)}
  onOk={handleAddNote}
  okText="Add"
>
  <div>
    <label className="block text-md font-medium text-gray-700 mb-1">Note</label>
    <TextArea
      rows={3}
      value={newNoteText}
      onChange={(e) => setNewNoteText(e.target.value)}
      placeholder="Enter note details..."
    />
  </div>
</Modal>

      <UploadDocumentModal
        open={isUploadDocumentModalOpen}
        handleClose={closeUploadDocumentModal}
        patientId={patientId}
        closeAfterTransition
      />
    </Content>
  );
}
